export default __webpack_public_path__ + "static/media/web-icon-blue.f1ebaf49.svg";